/* global axios */
import ApiClient from './ApiClient';

class NotificationSubscriptions extends ApiClient {
  constructor() {
    super('notification_subscriptions');
  }

  delete(authToken) {
    return axios.delete(this.url, {
      params: {
        auth: authToken,
      },
    });
  }

  test() {
    return axios.post(`${this.url}/test`);
  }
}

export default new NotificationSubscriptions();
